export enum AggregationTypeEnum {
    /// <summary>
    /// Divisione per TimeOfDay
    /// </summary>
    AggregateByTimeOfDay = 0,

    /// <summary>
    /// Divisione dei Bin per mese
    /// </summary>
    AggregateByMonth = 1,

    /// <summary>
    /// Divisione dei Bin per giorno della settimana
    /// </summary>
    AggregateByDayOfWeek = 2,

    /// <summary>
    /// Esecuzione della timeline con dettaglio al minuto
    /// </summary>
    // TimelineByMinutes = 3,

    /// <summary>
    /// Esecuzione della timeline con dettaglio allora
    /// </summary>
    TimelineByHours = 4,

    /// <summary>
    /// Esecuzione della timeline con dettaglio al giorno
    /// </summary>
    TimelineByDay = 5,

    /// <summary>
    /// Esecuzione della timeline con dettaglio al mese
    /// </summary>
    TimelineByMonth = 6,

    /// <summary>
    /// Esecuzione della timeline con dettaglio all'anno
    /// </summary>
    // TimelineByYear = 7,

    /// <summary>
    /// Calcolo del totale
    /// </summary>
    AbsoluteValue = 8,
}
